module.exports = __webpack_public_path__ + "img/4.02657c5b.jpg";